import React from 'react'
import { makeStyles, Typography, useTheme, useMediaQuery } from '@material-ui/core'
import AppbarLogo from 'assets/primary_logo.png'
import { Box } from '@mui/material'
import { colors } from 'utils/colors'

const LogoWithConference = ({ confName }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const classes = useStyles({ isMobile })

  return (
    <Box className={classes.container}>
      <Box className={classes.logoWrapper}>
        <img className={classes.logo} alt="Meet Symple Logo" src={AppbarLogo} />
      </Box>
      {confName && (
        <>
          <Box className={classes.divider} />
          <Typography className={classes.confName}>{confName}</Typography>
        </>
      )}
    </Box>
  )
}

const useStyles = makeStyles((_theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: (props) => (props.isMobile ? '0.5rem 0' : '1rem 0'),
    flexDirection: (props) => (props.isMobile ? 'column' : 'row'),
    width: '100%'
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: (props) => (props.isMobile ? 'center' : 'flex-start')
  },
  logo: {
    height: 55,
    width: 'auto',
    // maxWidth: 135,
    objectFit: 'contain'
  },
  divider: {
    height: (props) => (props.isMobile ? 2 : 28),
    width: (props) => (props.isMobile ? 80 : 2),
    backgroundColor: colors.lightDivider,
    margin: (props) => (props.isMobile ? '0.5rem 0' : '0 1rem')
  },
  confName: {
    fontSize: (props) => (props.isMobile ? '18px' : '22px'),
    fontWeight: 600,
    color: colors.black,
    textAlign: (props) => (props.isMobile ? 'center' : 'left')
  }
}))
export default LogoWithConference
